import { render, staticRenderFns } from "./createKnowledgeBase.vue?vue&type=template&id=689fae9f"
import script from "./createKnowledgeBase.vue?vue&type=script&lang=js"
export * from "./createKnowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./createKnowledgeBase.vue?vue&type=style&index=0&id=689fae9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports